import styled from "styled-components";

import { Modal } from "@similarweb/ui-components";

export const StyledModal = styled(Modal)`
    padding: 0px !important;
    min-height: 400px;
    max-height: 400px;
`;
